import { useState } from "react";
import { ConfirmModal } from "../../../Modals/ConfirmModal";
import { ToastManager } from "../../../common/ToastContainer";
import { SESSION_AUTH } from "../../../../helpers/auth";
import { useParams } from "react-router-dom";
import { EVENTS_SERVICES } from "../../../../services";
import FullPageProgress from "../../../common/FullPageProgress";
import { FileDownload as FileDownloadIcon } from "@mui/icons-material";

const EventOrgazinationInvestorCSV = () => {
  const [investorReport, setInvestorReport] = useState(false);
  const { accountId } = useParams();
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [loader, setLoader] = useState(false);

  const onDownload = () => {
    setInvestorReport(false);
    setLoader(true);
    EVENTS_SERVICES.exportInvestorCSV({
      userId: userSession.userId,
      id: accountId,
    })
      .then((data) => {
        if (data.code === 200) {
          ToastManager.addToast(data?.message);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  return (
    <>
      {loader && <FullPageProgress />}
      <button
        type="button"
        onClick={() => {
          setInvestorReport(true);
        }}
        className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
      >
        <FileDownloadIcon className="m-r-5" /> Export Investor Report
      </button>

      {investorReport && (
        <ConfirmModal
          title="Investor Report"
          message={`<p> <b> Do you want to export? `}
          request={investorReport}
          cancel={() => {
            setInvestorReport(false);
          }}
          accept={onDownload}
        />
      )}
    </>
  );
};

export default EventOrgazinationInvestorCSV;
